module.exports = __webpack_public_path__ + "img/zc.20ed27e0.png";